import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadBills = async () => {
  let response = await Axois.get('/vendor-bills').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  // return [];
}

export const loadOneBill = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/invoices');
        const responseData = await requests.data;
        return {...responseData, bill: {}, entry: { }};
        // return {journals: [], accounts:[], taxes: [], invoice: {}, entry:{},};

      default:
        let response = await Axois.get('/vendor-bills/find/'+action);
        const responseJson = await response.data;
        return responseJson;
        // return {journals: [], accounts:[], taxes: [], entry:{}, transactions:[]};
    }
  }catch (err) {
    console.log(err);
  }
}


const useVendorBills = () => {

  const save = async (data, success) => {
    try {
      const response = await Axois.post('/vendor-bills', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('saved_bill_response', {status: 'draft', number: responseData.number});
    }catch(err) {
      console.log(err);
    }
  };

  const postBill = async (number, data, success) => {
    try {
      const response = await Axois.patch('/vendor-bills/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('bill_posted', {status: 'posted', number: number});
    }catch (err) {
      console.log(err);
    }
  }

  const update = async (number, data, success) => {
    try {
      const response = await Axois.put('/vendor-bills/'+number, data);
      const responseData = await response.data;
      success(responseData.message);
      // EventEmitter.dispatch('saved_invoice_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };

  const saveBillDebitNote = async (data, success) => {
    try {
      const response = await Axois.post('/debit-notes', data);
      const responseData = await response.data;
      success(responseData.message);
      return responseData.number;
    }catch(err) {
      console.log(err);
    }
  };

  const createAndPost = async (data, success) => {
    try {
      const response = await Axois.post('/debit-notes/create-validate', data);
      const responseData = await response.data;
      success(responseData.message);
      return responseData.number;
    }catch (err) {
      console.log(err);
    }
  }

  return { save, update, postBill, createAndPost, saveBillDebitNote };
}


export default useVendorBills;